<template>
  <div>
    <!-- Job Single Content Starts -->
    <section class="job-single-content section-padding">
      <div class="container">
        <div class="row">
          <div class="col-lg-8">
            <div class="main-content">
              <div class="single-content1">
                <div class="single-job mb-4 d-lg-flex justify-content-between">
                  <div class="job-text">
                    <h4>Assistant Executive - Production/ Quality Control</h4>
                    <ul class="mt-4">
                      <li class="mb-3"><h5><i class="fa fa-map-marker"></i> new yourk, USA</h5></li>
                      <li class="mb-3"><h5><i class="fa fa-pie-chart"></i> Applied Chemistry & Chemical Engineering / Chemistry</h5></li>
                      <li><h5><i class="fa fa-clock-o"></i> Deadline Deadline: Dec 11, 2018</h5></li>
                    </ul>
                  </div>
                  <div class="job-btn align-self-center">
                    <a href="#" class="forth-btn">full time</a>
                  </div>
                </div>
              </div>
              <div class="single-content2 py-4">
                <h4>Senior Laravel Developer <br>It Park International, USA</h4>
                <p>Senectus non fames aenean montes fringilla. Ipsum phasellus sagittis porttitor quam malesuada montes molestie sollicitudin eleifend dis diam dapibus aenean suspendisse elit pretium, varius pharetra natoque penatibus aptent. Proin neque.</p>
              </div>
              <div class="single-content3 py-4">
                <h4>vacancy</h4>
                <span class="ml-4">03</span>
              </div>
              <div class="single-content4 py-4">
                <h4>job responsibility</h4>
                <p>Senectus non fames aenean montes fringilla. Ipsum phasellus sagittis porttitor quam malesuada montes molestie sollicitudin eleifend dis diam dapibus aenean suspendisse elit pretium, varius pharetra natoque penatibus aptent. Proin neque.</p>
                <ul>
                  <li class="mb-2">Mate dropped a clanger cuppa I chinwag  one plastered cheesed.</li>
                  <li class="mb-2">Mate dropped a clanger cuppa I chinwag  one plastered.</li>
                  <li class="mb-2">Dropped a clanger cuppa I chinwag  one plastered chee</li>
                  <li>Cuppa I chinwag  one plastered cheesed.</li>
                </ul>
              </div>
              <div class="single-content5 py-4">
                <h4>Educational Requirements</h4>
                <p>Diploma in Engineering in Computer Science & Engineering, Bachelor in Engineering (BEngg) in Engineering (BEngg) in Computer Science & Enginetering</p>
                <p>Skills Required: JavaScript,PHP,WordPress,HTML5 & CSS3</p>
              </div>
              <div class="single-content6 py-4">
                <h4>employment status</h4>
                <span>Part Time/Full Time</span>
              </div>
              <div class="single-content7 py-4">
                <h4>other benifits</h4>
                <ul class="mt-3">
                  <li class="mb-2">Mate dropped a clanger cuppa I chinwag  one plastered cheesed.</li>
                  <li class="mb-2">Mate dropped a clanger cuppa I chinwag  one plastered.</li>
                  <li class="mb-2">Dropped a clanger cuppa I chinwag  one plastered chee</li>
                  <li>Cuppa I chinwag  one plastered cheesed.</li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="sidebar">
              <div class="single-item mb-4">
                <h4 class="mb-4">jobs type</h4>
                <a href="#" class="sidebar-btn d-flex justify-content-between mb-3">
                  <span>Full Time</span>
                  <span class="text-right">25 job</span>
                </a>
                <a href="#" class="sidebar-btn d-flex justify-content-between mb-3">
                  <span>Part Time</span>
                  <span class="text-right">25 job</span>
                </a>
                <a href="#" class="sidebar-btn d-flex justify-content-between">
                  <span>Internship</span>
                  <span class="text-right">25 job</span>
                </a>
              </div>
              <div class="single-item mb-4">
                <h4 class="mb-4">job by location</h4>
                <a href="#" class="sidebar-btn d-flex justify-content-between mb-3">
                  <span>New York</span>
                  <span class="text-right">25 job</span>
                </a>
                <a href="#" class="sidebar-btn d-flex justify-content-between mb-3">
                  <span>California</span>
                  <span class="text-right">25 job</span>
                </a>
                <a href="#" class="sidebar-btn d-flex justify-content-between mb-3">
                  <span>Swizerland</span>
                  <span class="text-right">25 job</span>
                </a>
                <a href="#" class="sidebar-btn d-flex justify-content-between mb-3">
                  <span>Canada</span>
                  <span class="text-right">25 job</span>
                </a>
                <a href="#" class="sidebar-btn d-flex justify-content-between">
                  <span>Sweden</span>
                  <span class="text-right">25 job</span>
                </a>
              </div>
              <div class="single-item mb-4">
                <h4 class="mb-4">salary range</h4>
                <a href="#" class="sidebar-btn d-flex justify-content-between mb-3">
                  <span>$20,000-$30,000</span>
                  <span class="text-right">25 job</span>
                </a>
                <a href="#" class="sidebar-btn d-flex justify-content-between mb-3">
                  <span>$25,000-$45,000</span>
                  <span class="text-right">25 job</span>
                </a>
                <a href="#" class="sidebar-btn d-flex justify-content-between">
                  <span>$40,000-$70,000</span>
                  <span class="text-right">25 job</span>
                </a>
              </div>
              <div class="single-item">
                <h4 class="mb-4">filter by salary</h4>
                <input type="text" id="range" value="" name="range" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- Job Single Content End -->


    <!-- Newsletter Area Starts -->
    <section class="newsletter-area job-single section-padding">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="section-top text-center">
              <h2>Get job information daily</h2>
              <p>Subscribe to our newsletter and get a coupon code!</p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12">
            <form action="#">
              <input type="email" placeholder="Your email here" onfocus="this.placeholder = ''" onblur="this.placeholder = 'Your email here'" required>
              <button type="submit" class="template-btn">subscribe now</button>
            </form>
          </div>
        </div>
      </div>
    </section>
    <!-- Newsletter Area End -->
  </div>
</template>

<script>
  export default {}
</script>




// WEBPACK FOOTER //
// src/pages/JobSingle.vue